<template lang="pug">
#visualizar-operacoes-cda-wa
    BaseHeader(
        titulo='Visualizar operação',
        voltarPara,
        :exibeBotao='operacao.status !== "Em processamento"',
        :icon='exportandoRelatorio ? "el-icon-loading" : "el-icon-download"',
        btnTexto='Exportar relatório',
        @btnHeaderClicado='exportarRelatorio'
    )

    .view-container-base-header
        VisualizarOperacaoCdaWaDados(
            :operacao='operacao || {}',
            :buscandoOperacao='buscandoOperacao',
            :permitirEditar='permitirEditar',
            @mostrarModalEditarOperacao='mostrarModalEditarOperacao = true'
        )

        h2.mt-20 Resumo da operação
        VisualizarOperacaoCdaWaResumo(
            :status='operacao.status',
            :resumo='resumoOperacao',
            :buscando='buscandoResumo'
        )

        .totalizadores_operacao.mt-20
            .visualizar-operacoes-cda-wa__listagem-titulo
                h2 Volume por território
            .totalizadores__linha
                .lyra__cartao(v-loading='buscandoCars')
                    .informacoes
                        .totalizadores__header
                            .totalizadores__texto
                                | {{ 'Volume máximo inserido' }}
                            .totalizadores__texto.valor {{ volumeMaximoTerritorios }}

                .lyra__cartao(v-loading='buscandoCars')
                    .informacoes
                        .totalizadores__header
                            .totalizadores__texto
                                | {{ 'Volume médio inserido' }}
                            .totalizadores__texto.valor {{ volumeMedioTerritorios }}

                .lyra__cartao(v-loading='buscandoCars')
                    .informacoes
                        .totalizadores__header
                            .totalizadores__texto
                                | {{ 'Volume mínimo inserido' }}
                            .totalizadores__texto.valor {{ volumeMinimoTerritorios }}

        .visualizar-operacoes-cda-wa__listagem.mt-20
            .visualizar-operacoes-cda-wa__listagem-titulo
                h2 Listagem de imóveis
                el-checkbox(
                    v-if='operacao.status !== "Em processamento"',
                    v-model='apenasInconformes',
                    @change='buscarCarsDaOperacao'
                ) Mostrar apenas imóveis não conformes

            el-card(:body-style='{ padding: "5px" }')
                el-table(
                    :data='cars',
                    v-loading='buscandoCars',
                    element-loading-text='Buscando imóveis...',
                    ref='tabelaCars',
                    @selection-change='alterarCarsSelecionados',
                    @sort-change='sortChangeRequest'
                )
                    el-table-column(type='selection', width='50')
                    el-table-column(prop='codigoCar', label='CAR', width='400')

                    el-table-column(
                        v-if='operacao.status !== "Em processamento"',
                        prop='situacao',
                        label='Análise',
                        sortable='custom',
                        minWidth='100'
                    )
                        .template(
                            slot-scope='scope',
                            :class='corSituacao(scope.row.situacao)'
                        )
                            i(:class='getIcone(scope.row.situacao)')
                            | {{ legendaSituacao(scope.row.situacao, scope.row.condicao) }}

                    el-table-column(
                        prop='volume',
                        label='Volume informado',
                        sortable='custom',
                        minWidth='120'
                    )
                    el-table-column(
                        prop='capacidadeProdutiva',
                        label='Capacidade produtiva',
                        sortable='custom',
                        minWidth='130'
                    )
                        .template(slot-scope='scope')
                            span(v-if='scope.row.capacidadeProdutiva != "0t"') {{ scope.row.capacidadeProdutiva }}
                            span(v-if='scope.row.capacidadeProdutiva == "0t"') Não existem dados para essa cultura/safra/estado
                    el-table-column(
                        prop='valor',
                        label='Valor',
                        sortable='custom',
                        minWidth='100'
                    )
                    el-table-column(
                        label='Produtor',
                        sortable='custom',
                        minWidth='100'
                    )
                        .template(slot-scope='scope')
                            span {{ scope.row.nomeProdutor }} ({{ formatarDocumento(scope.row.documentoProdutor) }})

                    el-table-column(
                        label='Ações',
                        align='center',
                        fixed='right'
                    )
                        .template(slot-scope='scope')
                            el-dropdown.action-button
                                i.mdi.mdi-dots-vertical

                                el-dropdown-menu(slot='dropdown')
                                    el-dropdown-item(
                                        icon='el-icon-view',
                                        @click.native='visualizarAnalise(scope.row)',
                                        v-if='operacao.status !== "Em processamento"'
                                    ) Visualizar análise
                                    el-dropdown-item(
                                        v-if='!bloquearAcoes',
                                        icon='el-icon-delete',
                                        @click.native='removerCar(scope.row)'
                                    ) Remover

                    template(slot='empty')
                        el-empty(description='Sem dados')

                .visualizar-operacoes-cda-wa__listagem-rodape(v-if='cars')
                    .visualizar-operacoes-cda-wa__listagem-informacoes
                        p {{ totalCars }} {{ totalCars === 1 ? 'imóvel' : 'imóveis' }}

                    el-pagination(
                        background,
                        :page-size='paginacao.tamanhoPagina',
                        :current-page.sync='paginacao.paginaAtual',
                        layout='prev, pager, next',
                        :total='totalCars',
                        @current-change='atualizarPagina'
                    )

            .visualizar-operacoes-cda-wa__acoes.mt-20(v-if='!bloquearAcoes')
                BaseButton(
                    type='danger',
                    size='medium',
                    plain,
                    :icon='botaoRemoverImoveis.icone',
                    :disabled='botaoRemoverImoveis.desabilitado',
                    @click='removerCarsSelecionados'
                ) {{ botaoRemoverImoveis.texto }}

                .visualizar-operacoes-cda-wa__acoes-direita(
                    v-if='usuarioLogado.operacaoCdaWaAprovador && !bloquearAcoes'
                )
                    BaseButton(
                        type='primary',
                        size='medium',
                        icon='el-icon-circle-close',
                        @click='confirmarAcao(false)'
                    ) Reprovar operação
                    BaseButton(
                        type='primary',
                        size='medium',
                        icon='el-icon-check',
                        @click='confirmarAcao(true)'
                    ) Aprovar operação

    ModalConfirmarAprovarReprovarOperacaoCdaWa(
        :show='payloadModalConfirmar.mostrar',
        :identificador='payloadModalConfirmar.identificador',
        :aprovar='payloadModalConfirmar.aprovar',
        @fechar='payloadModalConfirmar.mostrar = false',
        @acao='payloadModalConfirmar.aprovar ? aprovarOperacao() : reprovarOperacao()'
    )

    ModalEditarOperacaoCdaWa(
        :mostrar='mostrarModalEditarOperacao',
        :operacao='operacao',
        :safras='safras',
        :culturas='culturas',
        @fechar='mostrarModalEditarOperacao = false',
        @atualizarSafras='buscarSafras',
        @atualizarCulturas='buscarCulturas',
        @operacaoAtualizada='buscarOperacaoPorId'
    )

    modal-resultado-diagnostico-operacao-cda-wa(
        ref='modalResultadoDiagnosticoRef',
        :carSelecionadoAnalise='carSelecionadoAnalise'
    )
</template>

<script>
import BaseHeader from '@/components/BaseHeader';

import { mapGetters } from 'vuex';
import ModalConfirmarAprovarReprovarOperacaoCdaWa from '@/components/operacao-cda-wa/ModalConfirmarAprovarReprovarOperacaoCdaWa.vue';
import ModalResultadoDiagnosticoOperacaoCdaWa from '@/components/operacao-cda-wa/ModalResultadoDiagnosticoOperacaoCdaWa.vue';
import VisualizarOperacaoCdaWaDados from '@/components/operacao-cda-wa/VisualizarOperacaoCdaWaDados.vue';
import VisualizarOperacaoCdaWaResumo from '@/components/operacao-cda-wa/VisualizarOperacaoCdaWaResumo.vue';
import ModalEditarOperacaoCdaWa from '@/components/operacao-cda-wa/ModalEditarOperacaoCdaWa.vue';
import BaseButton from '@/components/vegaComponents/BaseButton.vue';

import OperacaoCdaWaService from '@/services/OperacaoCdaWaService';
import formatters from '@/utils/formatters';

export default {
    name: 'OperacoesCdaWa',
    components: {
        ModalResultadoDiagnosticoOperacaoCdaWa,
        ModalConfirmarAprovarReprovarOperacaoCdaWa,
        BaseHeader,
        VisualizarOperacaoCdaWaDados,
        VisualizarOperacaoCdaWaResumo,
        ModalEditarOperacaoCdaWa,
        BaseButton
    },
    data() {
        return {
            operacao: {},
            buscandoOperacao: true,
            cars: [],
            buscandoCars: true,
            totalCars: 0,
            volumeMedioTerritorios: 100,
            volumeMaximoTerritorios: 0,
            volumeMinimoTerritorios: 0,
            apenasInconformes: false,
            paginacao: {
                page: 1,
                size: 10,
                sort: ''
            },
            order: null,
            nomeColumn: null,
            carsSelecionadosRemocao: [],
            botaoRemoverImoveis: {
                desabilitado: true,
                texto: 'Remover imóveis',
                icone: 'el-icon-delete'
            },
            removendoImoveis: false,
            payloadModalConfirmar: {
                mostrar: false,
                aprovar: false,
                payload: null
            },
            payloadModalDiagnostico: {
                mostrar: false,
                payload: null
            },
            resumoOperacao: {},
            buscandoResumo: true,
            mostrarModalEditarOperacao: false,
            safras: [],
            culturas: [],
            exportandoRelatorio: false,
            carSelecionadoAnalise: ''
        };
    },

    computed: {
        ...mapGetters(['usuarioLogado']),
        bloquearAcoes: function () {
            return (
                this.operacao.status === 'Em processamento' ||
                this.operacao.status === 'Aprovado' ||
                this.operacao.status === 'Reprovado' ||
                this.operacao.status === 'Vencido'
            );
        },

        permitirEditar: function () {
            return (
                this.usuarioLogado.operacaoCdaWaCadastrante &&
                this.operacao.status === 'Processado'
            );
        }
    },

    mounted() {
        this.buscarOperacaoPorId();
        this.buscarResumoPorIdOperacao();
        this.buscarCarsDaOperacao();

        if (this.operacao.status !== 'Em processamento') {
            this.buscarResumoPorIdOperacao();
            this.buscandoResumo = false;
        }
    },

    methods: {
        async aprovarOperacao() {
            await OperacaoCdaWaService.aprovarOperacao(
                this.payloadModalConfirmar.payload
            )
                .then(() => {
                    this.$notify.success({
                        message: 'Operação aprovada com sucesso.'
                    });
                    this.buscarOperacaoPorId();
                })
                .catch(rsp => {
                    if (rsp.response?.data?.message) {
                        this.$notify.error({
                            message: rsp.response?.data?.message
                        });
                    } else {
                        this.$notify.error({
                            message: 'Não foi aprovar a operação.'
                        });
                    }
                })
                .finally(() => {
                    this.payloadModalConfirmar.mostrar = false;
                });
        },
        async buscarOperacaoPorId() {
            this.buscandoOperacao = true;

            try {
                const { data } = await OperacaoCdaWaService.buscarOperacaoPorId(
                    this.$route.params.idOperacao
                );
                this.operacao = JSON.parse(data);
            } catch (e) {
                this.$notify.error(
                    'Não foi possível buscar dados da operação.'
                );
            } finally {
                this.buscandoOperacao = false;
            }
        },

        async buscarCarsDaOperacao() {
            this.buscandoCars = true;

            if (!this.order) {
                this.paginacao.sort = '&sort=situacao,asc';
            }

            const dados = {
                idOperacao: this.$route.params.idOperacao,
                apenasInconformes: this.apenasInconformes
            };

            try {
                const { data } =
                    await OperacaoCdaWaService.buscarCarsDaOperacao({
                        ...dados,
                        ...this.paginacao
                    });

                const {
                    itens,
                    totalItens,
                    volumeMedio,
                    volumeMaximo,
                    volumeMinimo
                } = JSON.parse(data);
                this.cars = itens;
                this.totalCars = totalItens;
                this.volumeMedioTerritorios = volumeMedio;
                this.volumeMaximoTerritorios = volumeMaximo;
                this.volumeMinimoTerritorios = volumeMinimo;
            } catch (e) {
                this.$notify.error(
                    'Não foi possível buscar os imóveis da operação.'
                );
            } finally {
                this.buscandoCars = false;
            }
        },

        confirmarAcao(ehAprovacao) {
            this.payloadModalConfirmar.aprovar = ehAprovacao;
            this.payloadModalConfirmar.payload = this.operacao.id;
            this.payloadModalConfirmar.identificador =
                this.operacao.identificador;
            this.payloadModalConfirmar.mostrar = true;
        },

        corSituacao(situacao) {
            if (situacao === 'INCONFORME') {
                return 'vermelho';
            } else if (situacao === 'CONFORME') {
                return 'verde';
            } else {
                return 'amarelo';
            }
        },

        legendaSituacao(situacao, condicao) {
            if (situacao === 'INCONFORME') {
                if (condicao === 'CA') {
                    return 'Cancelado';
                } else if (condicao === 'SU') {
                    return 'Suspenso';
                } else {
                    return 'Inconforme';
                }
            } else if (situacao === 'CONFORME') {
                return 'Conforme';
            } else {
                return ' Alerta';
            }
        },

        getIcone(situacao) {
            if (situacao === 'INCONFORME') {
                return 'mdi mdi-alert-circle danger';
            } else if (situacao === 'CONFORME') {
                return 'flow flow-verified';
            } else {
                return 'flow flow-warning-sign';
            }
        },

        atualizarPagina(pagina) {
            this.paginacao.page = pagina;
            this.buscarCarsDaOperacao();
        },

        async visualizarAnalise({ id, codigoCar, condicao }) {
            this.carSelecionadoAnalise = codigoCar;

            if (condicao === 'CA' || condicao === 'SU') {
                this.$notify.warning({
                    message:
                        'Não é possível realizar diagnóstico de um CAR cancelado ou inválido.'
                });
            } else {
                await OperacaoCdaWaService.buscarDiagnosticoComposicao(id)
                    .then(({ data }) => {
                        this.$refs.modalResultadoDiagnosticoRef.abrirModal(
                            data
                        );
                    })
                    .catch(() => {
                        this.$notify.error({
                            message:
                                'Não foi possível realizar a análise do imóvel.'
                        });
                    });
            }
        },

        alterarCarsSelecionados(linhas) {
            this.carsSelecionadosRemocao = linhas.map(({ id }) => id);
            this.botaoRemoverImoveis.desabilitado =
                this.carsSelecionadosRemocao.length === 0 ||
                this.removendoImoveis;
        },

        async reprovarOperacao() {
            await OperacaoCdaWaService.reprovarOperacao(
                this.payloadModalConfirmar.payload
            )
                .then(() => {
                    this.$notify.success({
                        message: 'Operação reprovada com sucesso.'
                    });
                    this.buscarOperacaoPorId();
                })
                .catch(rsp => {
                    if (rsp.response?.data?.message) {
                        this.$notify.error({
                            message: rsp.response?.data?.message
                        });
                    } else {
                        this.$notify.error({
                            message: 'Não foi possível reprovar a operação.'
                        });
                    }
                })
                .finally(() => {
                    this.payloadModalConfirmar.mostrar = false;
                });
        },

        removerCar({ id }) {
            this.$refs.tabelaCars.clearSelection();
            this.carsSelecionadosRemocao = [id];
            this.removerCarsSelecionados();
        },

        async removerCarsSelecionados() {
            this.removendoImoveis = true;
            this.botaoRemoverImoveis = {
                desabilitado: true,
                texto: 'Removendo imóveis',
                icone: 'el-icon-loading'
            };

            try {
                await OperacaoCdaWaService.removerCars(
                    this.carsSelecionadosRemocao
                );
                this.$notify.success('Imóveis removidos.');

                this.buscarCarsDaOperacao();
            } catch (e) {
                this.$notify.error(
                    'Ocorreu um erro ao remover os imóveis selecionados.'
                );
            } finally {
                this.removendoImoveis = false;

                this.$refs.tabelaCars.clearSelection();
                this.carsSelecionadosRemocao = [];

                this.botaoRemoverImoveis = {
                    desabilitado: false,
                    texto: 'Remover imóveis',
                    icone: 'el-icon-delete'
                };
            }
        },

        async exportarRelatorio() {
            if (this.exportandoRelatorio) return;

            try {
                this.exportandoRelatorio = true;
                await OperacaoCdaWaService.exportarAnalisePdf(
                    this.$route.params.idOperacao
                );

                this.$notify.success({
                    message: 'Análise exportada com sucesso!'
                });
            } catch (error) {
                this.$notify.error({
                    message: 'Erro ao exportar a análise!'
                });
            } finally {
                this.exportandoRelatorio = false;
            }
        },

        async buscarResumoPorIdOperacao() {
            this.buscandoResumo = true;

            try {
                const { data } = await OperacaoCdaWaService.buscarResumoPorId(
                    this.$route.params.idOperacao
                );

                this.resumoOperacao = JSON.parse(data);
            } catch (e) {
                this.$notify.error(
                    'Não foi possível buscar o resumo da operação.'
                );
            } finally {
                this.buscandoResumo = false;
            }
        },

        async buscarSafras() {
            const { data } = await OperacaoCdaWaService.buscarSafras();
            this.safras = data;
        },

        async buscarCulturas() {
            const { data } = await OperacaoCdaWaService.buscarCulturas();
            this.culturas = data;
        },

        sortChangeRequest(column) {
            this.order = null;

            if (column.order === 'ascending') {
                this.order = 'asc';
            } else if (column.order === 'descending') {
                this.order = 'desc';
            }

            this.nomeColumn = column.prop;
            this.fetchImoveis();
        },

        async fetchImoveis() {
            let filtro = this.getFiltros();
            this.paginacao.sort = filtro.order;

            this.buscarCarsDaOperacao();
        },

        getFiltros() {
            const filtro = {};
            filtro.size = this.paginacao.size;
            filtro.page = this.paginacao.page - 1;

            filtro.order = '&sort=situacao,asc';

            if (this.order && this.nomeColumn) {
                const nomesColunas = {
                    situacao: 'situacao',
                    volume: 'volume',
                    capacidadeProdutiva: 'capacidade_produtiva',
                    valor: 'valor'
                };
                const sort = nomesColunas[this.nomeColumn];
                filtro.order = `&sort=${sort},${this.order}`;
            }
            return filtro;
        },

        formatarDocumento(documento) {
            return formatters.numeralStringFormatToDocumento(documento);
        }
    }
};
</script>

<style lang="scss">
#visualizar-operacoes-cda-wa {
    h2 {
        display: block;
        font-size: 18px;
        font-weight: 500;
        margin-bottom: 10px;
    }

    .mt-20 {
        margin-top: 20px;
    }

    .vermelho {
        color: red;
    }

    .verde {
        color: green;
    }

    .vermelho,
    .verde {
        display: flex;
        align-items: center;
        gap: 4px;
    }

    .visualizar-operacoes-cda-wa__listagem {
        margin-bottom: 20px;

        .cell {
            word-break: normal;
        }

        .visualizar-operacoes-cda-wa__listagem-titulo {
            display: flex;
            justify-content: space-between;

            h2 {
                display: block;
                font-size: 18px;
                font-weight: 500;
                margin-bottom: 5px;
            }
        }

        .visualizar-operacoes-cda-wa__listagem-rodape {
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 10px 44% 5px 10px;

            .visualizar-operacoes-cda-wa__listagem-informacoes {
                display: flex;
                justify-content: flex-start;
                gap: 10px;

                p {
                    font-weight: bold;
                    color: var(--primary);
                    margin: 0;
                }
            }
        }
    }

    .visualizar-operacoes-cda-wa__acoes {
        display: flex;
        justify-content: space-between;
    }

    .status {
        margin-left: 20px;
        height: 25px;
        font-style: normal;
        background-color: var(--secondary);
        padding: 2px 6px;
        border-radius: 4px;
        font-weight: 600;
        color: black !important;
    }
}

.totalizadores_operacao {
    width: 100%;
    height: fit-content;
    display: flex;
    flex-direction: column;

    .totalizadores__linha {
        flex-grow: 1;
        display: grid;
        grid-template-columns: repeat(3, minmax(250px, 1fr));
        gap: 20px;
        margin-bottom: 8px;
    }

    .totalizadores__linha:last-child {
        margin-bottom: 0;
    }

    .lyra__cartao {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        min-height: 0;
        height: fit-content;
        flex: 1;
        justify-content: space-between;

        .informacoes {
            display: flex;
            width: 100%;
            height: fit-content;
            margin-top: 2rem;
            margin-bottom: 2rem;
            flex-direction: column;
            justify-content: space-between;
        }

        .totalizadores__header {
            display: flex;
            align-items: flex-start;
            justify-content: space-between;
        }

        .valor {
            display: flex;
            align-self: flex-start;
            margin-left: auto;
            margin-right: 2rem;
        }
    }

    .totalizadores__texto {
        font-size: 16px;
        font-weight: 700;
        margin: 0.5rem 0 0.5rem 2rem;
        text-align: left;
        color: var(--primary);
        height: 100%;
    }

    @media (max-width: 800px) {
        .totalizadores__linha {
            gap: 10px;
            grid-template-columns: repeat(3, minmax(100px, 1fr));
            width: 100%;
        }
        .lyra__cartao {
            justify-content: center;
            max-width: 100%;

            .valor {
                margin-right: 1rem;
                margin-left: 1rem;
            }
        }

        .lyra__cartao .informacoes {
            margin-top: 1rem;
        }
    }

    @media (min-width: 1440px) {
        .totalizadores__linha {
            gap: 20px;
            grid-template-columns: repeat(3, minmax(100px, 1fr));
        }
        .lyra__cartao {
            max-height: 300px;
            justify-content: center;
            max-width: inherit;
        }
    }
    @media (min-height: 1200px) {
        height: 50%;
        .totalizadores__linha {
            width: 100%;
            height: 100%;
            grid-template-columns: repeat(3, minmax(100px, 0.5fr));
        }
        .lyra__cartao {
            max-width: 450px;
            width: 100%;
            height: 100%;
        }
    }
}
</style>
